import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
export const getMFABlockPageUrl = function () {
  let {
    accountId,
    projectId,
    redirectUrl
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!accountId) {
    return `/page-not-found`;
  }
  let baseUrl = `${getAccHostname()}/access/mfa/accounts/${accountId}`;
  if (projectId) {
    baseUrl += `/projects/${projectId}`;
  }
  if (redirectUrl) {
    return `${baseUrl}?redirectUrl=${encodeURIComponent(redirectUrl)}`;
  }
  return baseUrl;
};
//# sourceMappingURL=getMFABlockPageUrl.js.map